import React from 'react';

import { Text } from './text';

import { useTheme } from '@/components/theme-provider';

export interface HelperTextProps {
	children: React.ReactNode;
	type?: 'error' | 'info';
	visible?: boolean;
	style?: any;
}

export const HelperText: React.FC<HelperTextProps> = ({
	children,
	type = 'info',
	visible = true,
	style,
}) => {
	const theme = useTheme();

	if (!visible) return null;

	const color = type === 'error' ? theme.colors.error : theme.colors.onSurfaceVariant;

	return (
		<Text variant="bodySmall" style={[{ color, marginTop: 4 }, style]}>
			{children}
		</Text>
	);
};
